import { render, staticRenderFns } from "./UserEditCard.vue?vue&type=template&id=0f0e9b26"
import script from "./UserEditCard.vue?vue&type=script&lang=js"
export * from "./UserEditCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports